import { useForceAppRefresh } from './useForceAppRefresh'

export const ForceAppRefresh = () => {
  useForceAppRefresh()
  return null
}
